import { render } from "./HostControls.vue?vue&type=template&id=7315e9de"
import script from "./HostControls.vue?vue&type=script&lang=js"
export * from "./HostControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__